// Reviews Widget Editing
$(document).ready(function () {
  const iconCaret = `<svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
                    </svg>
                    `;

  $(window).on("scroll", function () {
    const scrollPosition = $(this).scrollTop();
    const headerTabs = $(".header-tabs-wrapper");

    if (scrollPosition >= headerTabs.height()) {
      headerTabs.addClass("scrolled");
    } else {
      headerTabs.removeClass("scrolled");
    }
  });

  // Review Widget
  $(".jdgm-carousel-item__product").each(function () {
    $(this).parent().prepend(this);
  });
  $(".jdgm-carousel-item__reviewer-name-wrapper").each(function () {
    $(this).siblings(".jdgm-carousel-item__review").append(this);
  });
  // Review Widget

  // Play video carouesell
  $(".item_video").on("click", function () {
    const video = $(this).find("video")[0];
    const playButton = $(this).find(".item_video-play");
    if (video.paused) {
      $(video).trigger("play");
      $(playButton).fadeOut();
      $(this).css("cursor", "default");
    } else {
      $(video).trigger("pause");
      $(playButton).fadeIn();
      $(this).css("cursor", "pointer");
    }
  });

  // Play video carouesell

  // Play video productPage

  $(".productPage__reformerApp-col1").on("click", function () {
    const video = $(this).find("video")[0];
    const text = $(this).find("h2");
    const col2 = $(".productPage__reformerApp-col2");
    console.log(window.innerWidth);
    if (video.paused) {
      if (window.innerWidth < 990) {
        col2.fadeOut();
      }
      $(text).fadeOut();
      $(video).trigger("play");
      $(this).css("cursor", "default");
    } else {
      if (window.innerWidth < 990) {
        col2.fadeIn();
      }
      $(text).fadeIn();
      $(video).trigger("pause");
      $(this).css("cursor", "pointer");
    }
  });
  // Play video productPage

  // Video fullscreen on dblclick
  $("video").on("dblclick", function () {
    const video = $(this)[0];
    if (video) {
      if (video.requestFullscreen) {
        video.requestFullscreen();
      } else if (video.webkitRequestFullscreen) {
        video.webkitRequestFullscreen();
      } else if (video.msRequestFullscreen) {
        video.msRequestFullscreen();
      }
    }
  });
  // Video fullscreen on dblclick

  // BreadCrumbs top on mobile
  if (window.innerWidth < 990) {
    $(".breadcrumbs").insertBefore($(".product__media-wrapper"));
  }
  // BreadCrumbs top on mobile

  // Anchor smooth scroll
  $(document).on("click", 'a[href*="#"]', function (e) {
    const targetId = $(this).attr("href");
    const isFancybox = $(this).attr("data-fancybox") !== undefined;

    if (
      !targetId.includes("/") &&
      !isFancybox &&
      !$(this).hasClass("jdgm-rev__read-full") &&
      !$(this).hasClass("jdgm-btn")
    ) {
      e.preventDefault();
      const targetElement = $(targetId);
      if (targetElement.length) {
        const offsetTop = targetElement.offset()?.top;
        $("html, body").animate(
          {
            scrollTop: offsetTop,
          },
          800
        );
      }
    }
  });
  // Anchor smooth scroll

  $(".shopify-section.section .buy-buttons-wrapper").prepend(
    $(".product-form__input.product-form__quantity")
  );

  // HubSpot Popup (replaces Klaviyo popup)
  $('a[href="#klaviyo-popup"]').on("click", function (event) {
    event.preventDefault();
    const formId = window.yr && window.yr.settings && window.yr.settings['hubspot_popup_form_id'];
    if (!formId) return;

    let modal = document.querySelector('dynamic-popup-modal[data-hs-popup]');
    if (!modal) {
      modal = document.createElement('dynamic-popup-modal');
      modal.setAttribute('data-hs-popup', 'true');
      document.body.appendChild(modal);
    }

    const hsContent = `<script src="https://js-ap1.hsforms.net/forms/embed/developer/441815052.js" defer><\/script><div class="hs-form-html" data-region="ap1" data-form-id="${formId}" data-portal-id="441815052"></div>`;
    modal.openWithContent(hsContent);
  });

  $('a[href="#klaviyo-popup2"]').on("click", function (event) {
    event.preventDefault();
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(["openForm", "R24bK4"]);
  });

  // Launch banners

  const launchBanners = $('div[id*="launch_banner"]');
  const newDiv = $('<div id="launch__banners"></div>');
  launchBanners.first().before(newDiv);
  launchBanners.each(function () {
    $(this).appendTo(newDiv);
  });
  $("#launch__banners").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    arrows: true,
    prevArrow: `<div class="slick-prev">${iconCaret}</div>`,
    nextArrow: `<div class="slick-next">${iconCaret}</div>`,
  });
});

// Location Custom Select
$(document).ready(function () {
  const itemsList = $(".location-selector ul");
  const arrow = $(".location-selector").find("svg");

  $(".location-selector button").on("click", function (event) {
    event.stopPropagation();
    event.preventDefault();
    if (itemsList.hasClass("active")) {
      itemsList.fadeOut();
      itemsList.removeClass("active");
      arrow.css("rotate", "0deg");
      $(this).attr("aria-expanded", false);
    } else {
      itemsList.fadeIn();
      itemsList.addClass("active");
      arrow.css("rotate", "180deg");
      $(this).attr("aria-expanded", true);
    }
  });

  $(document).on("click", function (event) {
    if (itemsList.hasClass("active") && !$(event.target).closest(".location-selector").length) {
      itemsList.fadeOut();
      itemsList.removeClass("active");
      arrow.css("rotate", "0deg");
      $(".location-selector button").attr("aria-expanded", false);
    }
  });
});
// Location Custom Select

// Product description read more
$(document).ready(function () {
  const tabs = $(".product__description-tabs .tab");
  const panes = $(".product__description-tabscontent .tabcontent");
  tabs.on("click", function () {
    const clickedIndex = tabs.index(this);
    tabs.removeClass("active");
    $(this).addClass("active");
    panes.hide();
    panes.eq(clickedIndex).fadeIn();
  });

  $(window).on("load", function () {
    tabs.first().trigger("click");
  });

  if (window.innerWidth < 990) {
    $(".read-more").click(function (e) {
      e.preventDefault();
      const content = $(this).prev("div");

      if (content.hasClass("expanded")) {
        content.removeClass("expanded");
        $(this).text("Read more");
      } else {
        content.addClass("expanded");
        $(this).text("Read less");
      }
    });
  }
});
// Product description read more

// Globo select aria-label
$(window).on("load", function () {
  const globoForms = document.querySelectorAll(".globo-formbuilder");
  globoForms.forEach((form) => {
    const formSelects = form.querySelectorAll(".globo-form-control[data-type='select']");
    formSelects.forEach((selectDiv) => {
      const select = selectDiv.querySelector("select");
      const selectLabel = selectDiv.querySelector("label");
      if (select && selectLabel) {
        const labelText = selectLabel.getAttribute("data-label");
        select.setAttribute("aria-label", labelText);
      }
    });
  });
});

// B2B Show Discounts
document.addEventListener("DOMContentLoaded", async function () {
  const displayDiscountProducts = document.querySelectorAll("[data-product][data-discount-code]");
  const discountCodes = [];
  displayDiscountProducts.forEach((product) => {
    const discountCode = product.getAttribute("data-discount-code");
    if (!discountCodes.includes(discountCode)) {
      discountCodes.push(discountCode);
    }
  });
  await Promise.all(
    discountCodes.map(async (discountCode) => {
      const reqBody = {
        shop: "yourreformer-usa.myshopify.com",
        discountCode: discountCode,
      };
      const response = await fetch("https://b2bdiscountvariants-nb5mx4io6q-uc.a.run.app", {
        headers: {
          "Content-Type": "application/json",
        },
        method: "POST",
        body: JSON.stringify(reqBody),
      });
      const data = await response.json();
      console.log(data);
      displayDiscountProducts.forEach((product) => {
        const productId = product.getAttribute("data-product");
        const productWrapper = document.querySelector(`#b2b-product-${productId}`);
        if (productWrapper) {
          const variantNodes = productWrapper.querySelectorAll(
            ".b2b-product-variants-grid-items-item"
          );
          variantNodes.forEach((variantNode) => {
            const variantId = variantNode.getAttribute("data-variant");
            if (data.variants.includes(variantId)) {
              const discountSpan = variantNode.querySelector(
                ".b2b-product-variants-grid-items-item-discount"
              );
              discountSpan.textContent = data.code;
              discountSpan.hidden = false;
            }
          });
        }
      });
    })
  );
});
// B2B Show Discounts
